module.exports = __webpack_public_path__ + "img/bk_07.a244d960.png";